import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "9", cy: "7", r: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "19", cy: "11", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19 8v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19 13v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m21.6 9.5-.87.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m17.27 12-.87.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m21.6 12.5-.87-.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m17.27 10-.87-.5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "UserCog";
const UserCog = memo(themed(Icon));
export {
  UserCog
};
//# sourceMappingURL=user-cog.js.map
